import React, { useState, useEffect } from "react";
import axios from "axios";
import { HashLink } from "react-router-hash-link";
import praxisInfosData from "../../data/praxisInfoList.json";

function ContactForm({ AfterSubmitAction }) {
  const [formData, setFormData] = useState({
    fullName: "",
    mail: "",
    subject: "",
    message: "",
    praxis: "",
  });

  const onSubmitForm = (e) => {
    e.preventDefault();
    sendSuggMail();
  };

  const sendSuggMail = async () => {
    var data = {
      fullName: formData.fullName,
      mail: formData.mail,
      subject: formData.subject,
      praxis: formData.praxis,
      message: formData.message,
    };

    axios.post("server/sendContactMail.php", data).then(function (response) {
      AfterSubmitAction(true);
    });
  };

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <form data-type="contact" onSubmit={onSubmitForm}>
      <div className="form-control">
        <label htmlFor="fullName" className="form-label">
          Name
        </label>
        <input
          className="form-input"
          onChange={handleChange}
          type="text"
          name="fullName"
          required
        />
      </div>

      <div className="form-control">
        <label htmlFor="mail" className="form-label">
          E-Mail
        </label>
        <input
          className="form-input"
          onChange={handleChange}
          type="mail"
          name="mail"
          required
        />
      </div>

      <div className="form-control">
        <label htmlFor="subject" className="form-label">
          Betreff
        </label>
        <input
          className="form-input"
          onChange={handleChange}
          type="text"
          name="subject"
          required
        />
      </div>

      <div className="form-control">
        <label htmlFor="subject" className="form-label">
          Anfrage für Praxis
        </label>
        <select
          className="form-input"
          onChange={handleChange}
          type="dropdown"
          name="praxis"
          required>
          <option value="none" selected>
            Praxis auswählen ...
          </option>
          {praxisInfosData[0]["Allgemeinmedizin/Hausarzt"].map(
            (praxis, index) => (
              <option key={index} value={praxis.doctor}>
                {praxis.doctor + " [" + praxis.fakultat + "]"}
              </option>
            ),
          )}
          {praxisInfosData[0]["Hals-Nasen-Ohrheilkunde"].map(
            (praxis, index) => (
              <option key={index} value={praxis.doctor}>
                {praxis.doctor + " [" + praxis.fakultat + "]"}
              </option>
            ),
          )}
          <option
            key={praxisInfosData[0]["Frauenheilkunde und Geburtshilfe"]}
            value={
              praxisInfosData[0]["Frauenheilkunde und Geburtshilfe"].doctor
            }>
            {praxisInfosData[0]["Frauenheilkunde und Geburtshilfe"].doctor +
              " [" +
              praxisInfosData[0]["Frauenheilkunde und Geburtshilfe"].fakultat +
              "]"}
          </option>
          {praxisInfosData[0]["Innere Medizin und Diabetologie"].map(
            (praxis, index) => (
              <option key={index} value={praxis.doctor}>
                {praxis.doctor + " [" + praxis.fakultat + "]"}
              </option>
            ),
          )}
          {praxisInfosData[0]["Kinder- und Jugendmedizin"].map(
            (praxis, index) => (
              <option key={index} value={praxis.doctor}>
                {praxis.doctor + " [" + praxis.fakultat + "]"}
              </option>
            ),
          )}
          {praxisInfosData[0]["Rheumatologie"].map((praxis, index) => (
            <option key={index} value={praxis.doctor}>
              {praxis.doctor + " [" + praxis.fakultat + "]"}
            </option>
          ))}
          <option
            key={praxisInfosData[0]["Urologie"]}
            value={praxisInfosData[0]["Urologie"].doctor}>
            {praxisInfosData[0]["Urologie"].doctor +
              " [" +
              praxisInfosData[0]["Urologie"].fakultat +
              "]"}
          </option>
        </select>
      </div>

      <div className="form-control">
        <label htmlFor="message" className="form-label">
          Nachricht
        </label>
        <textarea
          className="form-input"
          onChange={handleChange}
          name="message"
          required
        />
      </div>
      <div className="form-control">
        <span className="form-control-info">
          <input
            type="checkbox"
            placeholder="Datenschutz"
            required
            name="datenschutz"
          />
          <span>
            Ich willige in die in der{" "}
            <HashLink to="/datenschutz">Datenschutzerklärung</HashLink>{" "}
            beschriebene Verarbeitung meiner Daten ein:{" "}
            <span className="form-control-info-hl">*</span>
          </span>
        </span>
      </div>
      <button type="submit" className="btn">
        Absenden
      </button>
    </form>
  );
}

export default ContactForm;
